var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 24H14.6667V21.3333H17.3333V24ZM12 20V25.3333C12 26.0666 12.6 26.6666 13.3333 26.6666H18.6667C19.4 26.6666 20 26.0666 20 25.3333V20C20 19.2666 19.4 18.6666 18.6667 18.6666H13.3333C12.6 18.6666 12 19.2666 12 20ZM25.3333 12.4V6.66663C25.3333 5.93329 24.7333 5.33329 24 5.33329H22.6667C21.9333 5.33329 21.3333 5.93329 21.3333 6.66663V8.79996L16.8933 4.79996C16.3867 4.34663 15.6133 4.34663 15.1067 4.79996L3.96001 14.84C3.50668 15.24 3.78668 16 4.40001 16H6.14668C6.48001 16 6.80001 15.88 7.04001 15.6533L16 7.58663L24.9467 15.6533C25.2 15.88 25.52 16 25.84 16H27.5867C28.2 16 28.4933 15.24 28.0267 14.84L25.3333 12.4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.9402910f0aecba8a024a21d9451992bf.svg";
export { ForwardRef as ReactComponent };